import { tabletBreakPoint, mobileBreakPoint } from '../../../styles/globals/globalVars';


const isDesktop = () => window.innerWidth > parseInt(tabletBreakPoint, 10);

const isMobile = () => window.innerWidth <= parseInt(mobileBreakPoint, 10);

export {
  isDesktop,
  isMobile
};
